// 하드웨어 축 key. label 로 받지 않는다(Embodiment 카탈로그 전용 축).
// backend entity/label/reserved.py 의 HARDWARE_AXIS_KEYS 를 복사한 목록이다. 라벨 추가 UI 가
// 자유(generic) key 입력에서 이 key 들을 먼저 막는다. 서버도 같은 key 를 422
// `label.hardware_key` 로 거부한다. 입력 단계에서 막으면 사용자가 더 빨리 알 수 있다.
export const HARDWARE_AXIS_KEYS: readonly string[] = [
  "embodiment",
  "arms",
  "end_effector",
  "end_effector_tag",
  "camera_channel",
  "camera_count",
];
